export function addInputClasses() {
  document.addEventListener('mousedown', addMouseClass);
  document.addEventListener('keydown', addKbClass);
}

export function removeInputClasses() {
  document.removeEventListener('mousedown', addMouseClass);
  document.removeEventListener('keydown', addKbClass);
}

function addMouseClass() {
  document.body.classList.add('is-using-mouse');
  document.body.classList.remove('is-using-keyboard')
}

function addKbClass() {
  document.body.classList.remove('is-using-mouse');
  document.body.classList.add('is-using-keyboard')
}



// WEBPACK FOOTER //
// ./src/lib/userInputType.js